<template>
    <div id="AddIntegration" class="container" v-animate-css="{ classes: 'fadeInDown', delay: 0, duration: 300 }">
        <div class="header">
            <p>{{ $t("message.addIntegration") }}</p>
            <span
                style="
                    display: flex;
                    flex-direction: row;
                    justify-content: end;
                    text-align: center;
                    align-items: center;
                "
            >
                <a-icon style="font-size: 21px" type="close" v-if="bar !== 0" @click="$emit('close-menu', 0)" />
            </span>
        </div>
        <div class="content">
            <AddIntegrationItem
                :story-id="storyId"
                :itemText="$t('chatbotv2.chatWidget')"
                integration-type="web"
                @connect-event="supsisWebIntegration"
                @remove-story="removeWebIntegration"
            />
            <AddIntegrationItem
                :story-id="storyId"
                :itemText="$t('message.distWhatsapp')"
                integration-type="whatsapp"
            />
            <AddIntegrationItem
                :story-id="storyId"
                :itemText="'Whatsapp Business API'"
                integration-type="whatsapp-business-api"
            />
            <AddIntegrationItem :story-id="storyId" :itemText="'Instagram'" integration-type="instagram" />
            <AddIntegrationItem :story-id="storyId" :itemText="'Messenger'" integration-type="messenger" />
            <AddIntegrationItem
                :story-id="storyId"
                :itemText="'Telegram'"
                integration-type="telegram"
                @connect-event="telegramIntegration"
                @remove-story="removeTelegramIntegration"
            />
            <AddIntegrationItem
                :story-id="storyId"
                :itemText="'Trendyol'"
                integration-type="trendyol"
                @connect-event="telegramIntegration"
                @remove-story="removeTelegramIntegration"
            />
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import AddIntegrationItem from "./AddIntegrationItem.vue";
import { sendSocketMessage } from "../../../../../../utils/socketStream";
import _ from "lodash";

export default {
    name: "AddIntegration",
    props: {
        bar: {
            type: Number,
            default: 6,
        },
        storyId: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            chatbotStory: this.storyId,
            isChangedStory: false,
        };
    },
    components: {
        AddIntegrationItem,
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            settings: (state) => state.setting.settings,
        }),
        token: {
            get() {
                return _.get(this.settings, "telegrambot.token", null);
            },
            set(value) {
                this.setValue("telegrambot.token", value);
            },
        },
    },

    methods: {
        ...mapActions({
            makeDefaultStory: "CB/makeDefaultStory",
            revokeDefaultStory: "CB/revokeDefaultStory",
        }),
        supsisWebIntegration() {
            if (!this.chatbotStory) return;
            this.makeDefaultStory({ selectedStory: this.storyId, integrationApp: "supsisWidget" });
            this.isChangedStory = false;
            this.$message.success(this.$t("message.chatbotScenarioReleased"));
        },
        removeWebIntegration() {
            this.revokeDefaultStory({ integrationApp: "supsisWidget" });
            this.$emit("modal-visible", false);
            this.$message.success(this.$t("message.chatbotScenarioHasBeenCanceled"));
        },
        telegramIntegration() {
            if (!this.token) {
                this.$message.error(this.$t("Telegram Bot Token is required"));
                this.$router.push({ path: "/integrations", query: { showModal: "true" } });
                return;
            }
            if (!this.chatbotStory) return;
            this.makeDefaultStory({ selectedStory: this.storyId, integrationApp: "telegram" });
            this.$emit("modal-visible", false);
            this.isChangedStory = false;
            sendSocketMessage("user settings-updated", {
                siteId: this.site._id,
            });
            this.$message.success(this.$t("message.chatbotScenarioReleased"));
        },
        removeTelegramIntegration() {
            this.revokeDefaultStory({ integrationApp: "telegram" });
            this.$message.success(this.$t("message.chatbotScenarioHasBeenCanceled"));
        },
    },
};
</script>
<style lang="scss" scoped>
.container {
    padding-bottom: 30px !important;
    box-shadow: 0 4px 20px #00000040;
    background: #ffffff;
    border-radius: 4px;
    width: 100%;
    overflow-y: auto;
    min-width: 440px;
    max-height: 523px;
    //padding: 0 30px;

    .header {
        display: flex;
        justify-content: space-between;
        align-items: center !important;
        width: 100%;
        height: 80px;
        font-weight: 600;

        p {
            font-size: 18px;
            line-height: 23px;
            margin: 0;
        }
    }
}
</style>
